const COMPANION_API_URL = process.env.REACT_APP_COMPANION_API_URL;

export async function submitPublicFeatureRequest(payload) {
  if (!COMPANION_API_URL) {
    throw new Error('Companion API is not configured.');
  }

  const res = await fetch(`${COMPANION_API_URL}/api/feature-requests/public`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Could not submit your suggestion.');
  }
  return data;
}
